import { LazyMotion, domAnimation, m } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
const RIGHT_IMAGES = [
  "/images/Hiru/public_images/BBC70E26-89D8-475D-A68B-CA85A81C2953.webp",
  "/images/Hiru/public_images/680A0954-Enhanced-NR-Edit-copy-2.webp",
  "/images/Hiru Aadya.webp",
  "/images/Hiru Mudra.webp",
  "/images/Hiru/public_images/680A2344-copy.webp"
];
const HomeWelcomeSection = () => {
  return <section className="relative w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28 overflow-hidden">
            <div className="container mx-auto px-4">
                {
    /* Mobile Layout - sm and below */
  }
                <div className="lg:hidden flex flex-col gap-6">
                    {
    /* Heading */
  }
                    <LazyMotion features={domAnimation}>
                        <m.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
                            <h2 className="font-serif text-2xl sm:text-3xl font-light leading-none tracking-tighter text-[#1f4d3c]">
                                Ayubowan – willkommen auf<br />
                                der Insel der Heilung, Sri Lanka
                            </h2>
                        </m.div>
                    </LazyMotion>

                    {
    /* Images */
  }
                    <LazyMotion features={domAnimation}>
                        <m.div
    initial={{ opacity: 0, scale: 0.94, y: 30 }}
    whileInView={{ opacity: 1, scale: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
    className="relative"
  >
                            <div className="overflow-hidden rounded-3xl border border-amber-100 shadow-2xl h-[300px] sm:h-[400px] w-full">
                                <Swiper
    modules={[Autoplay, FreeMode]}
    spaceBetween={0}
    slidesPerView={1}
    loop={true}
    speed={6e3}
    freeMode={true}
    autoplay={{
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }}
    className="h-full w-full"
  >
                                    {RIGHT_IMAGES.map((src, idx) => <SwiperSlide key={idx} className="w-full h-full">
                                            <img
    src={src}
    alt={`Hiru Resort Galerie ${idx + 1}`}
    className="h-full w-full object-cover"
    width={400}
    height={400} loading="eager" fetchPriority="high" />
                                        </SwiperSlide>)}
                                </Swiper>
                            </div>
                            <div className="absolute -inset-4 -z-10 rounded-[2.5rem] border border-amber-200/60" />
                        </m.div>
                    </LazyMotion>

                    {
    /* Content */
  }
                    <LazyMotion features={domAnimation}>
                        <m.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8, delay: 0.2 }}
  >
                            <p className="mt-4 text-[17px] leading-relaxed text-gray-700">
                                Auf Sinhala bedeutet „Hiru“ „Sonne“. Bei Hiru Resorts legen wir großen Wert auf angenehmen Ausgleich, Wärme und tiefe Stille. Seit über 12 Jahren begleiten wir unsere Gäste durch die Tradition der Ayurveda, damit sie jeden Tag in innerer Fülle leben können.
                            </p>

                            <p className="mt-6 text-xl font-light text-amber-800">
                                Der Beginn einer ruhigen Reise
                            </p>

                            <div className="prose mt-6 max-w-2xl text-[15px] leading-relaxed text-gray-700">
                                <p>
                                    Unter regelmäßiger ärztlicher Begleitung erleben Sie eine echte Panchakarma-Kur, durch die neue Energie und ein gesunder Ausgleich zurückkehren. Ayurveda-Gerichte, die auf Ihre Konstitution abgestimmt sind, und die Yoga-Pavillons in der Natur tragen dazu bei, dass Ihre innere Balance wieder wie ein ruhiges Meer wird.
                                </p>
                                <br />
                                <p>
                                    Was wir unseren Gästen geben möchten, ist mehr als nur eine vorübergehende Pause. Wir möchten Sie in eine Atmosphäre des Wohlgefühls begleiten, die an Zuhause erinnert – ein Ort, an dem Sie sich selbst wiederfinden und jeden Moment bewusster leben können.
                                </p>
                            </div>
                        </m.div>
                    </LazyMotion>
                </div>

                {
    /* Desktop Layout - lg and above */
  }
                <div className="hidden lg:grid lg:grid-cols-12 lg:items-center lg:gap-16">
                    {
    /* Left Content */
  }
                    <div className="lg:col-span-7">
                        <LazyMotion features={domAnimation}>
                            <m.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
                                <h2 className="font-serif text-[2.75rem] font-light leading-none tracking-tighter text-[#1f4d3c] xl:text-5xl">
                                    Ayubowan – willkommen auf<br />
                                    der Insel der Heilung, Sri Lanka
                                </h2>

                                <p className="mt-8 max-w-2xl text-[17px] leading-relaxed text-gray-700 lg:text-lg">
                                    Auf Sinhala bedeutet „Hiru“ „Sonne“. Bei Hiru Resorts legen wir großen Wert auf angenehmen Ausgleich, Wärme und tiefe Stille. Seit über 12 Jahren begleiten wir unsere Gäste durch die Tradition der Ayurveda, damit sie jeden Tag in innerer Fülle leben können.
                                </p>

                                <p className="mt-8 text-2xl font-light text-amber-800">
                                    Der Beginn einer ruhigen Reise
                                </p>
                            </m.div>

                            <div className="prose mt-10 max-w-2xl text-[17.5px] leading-relaxed text-gray-700 lg:prose-lg">
                                <p>
                                    Unter regelmäßiger ärztlicher Begleitung erleben Sie eine echte Panchakarma-Kur, durch die neue Energie und ein gesunder Ausgleich zurückkehren. Ayurveda-Gerichte, die auf Ihre Konstitution abgestimmt sind, und die Yoga-Pavillons in der Natur tragen dazu bei, dass Ihre innere Balance wieder wie ein ruhiges Meer wird.
                                </p>
                                <br />
                                <p>
                                    Was wir unseren Gästen geben möchten, ist mehr als nur eine vorübergehende Pause. Wir möchten Sie in eine Atmosphäre des Wohlgefühls begleiten, die an Zuhause erinnert – ein Ort, an dem Sie sich selbst wiederfinden und jeden Moment bewusster leben können.
                                </p>
                            </div>
                        </LazyMotion>
                    </div>

                    {
    /* Right Image Slider */
  }
                    <div className="lg:col-span-5">
                        <LazyMotion features={domAnimation}>
                            <m.div
    initial={{ opacity: 0, scale: 0.94, y: 30 }}
    whileInView={{ opacity: 1, scale: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
    className="relative"
  >
                                <div className="overflow-hidden rounded-3xl border border-amber-100 shadow-2xl h-[520px] w-full">
                                    <Swiper
    modules={[Autoplay, FreeMode]}
    spaceBetween={0}
    slidesPerView={1}
    loop={true}
    speed={6e3}
    freeMode={true}
    autoplay={{
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }}
    className="h-full w-full"
  >
                                        {RIGHT_IMAGES.map((src, idx) => <SwiperSlide key={idx} className="w-full h-full">
                                                <img
    src={src}
    alt={`Hiru Resort Galerie ${idx + 1}`}
    className="h-full w-full object-cover"
    width={800}
    height={520} loading="eager" fetchPriority="high" />
                                            </SwiperSlide>)}
                                    </Swiper>
                                </div>

                                {
    /* Decorative Frame */
  }
                                <div className="absolute -inset-4 -z-10 rounded-[2.5rem] border border-amber-200/60" />
                            </m.div>
                        </LazyMotion>
                    </div>
                </div>
            </div>
        </section>;
};
export default HomeWelcomeSection;
